module.exports = __webpack_public_path__ + "media/21.875c1f07.mp3";